var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.setDimensions),expression:"setDimensions"}],attrs:{"id":"app"}},[_c('h1',{attrs:{"hidden":""}},[_vm._v(" Electrification Tools ")]),_c('router-view',{key:_vm.$route.path})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }